import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import "../custom-tree.css";
import { MdVerified } from "react-icons/md";
import Dashboardheader from "../directives/dashboardheader";
import {
  ProfileUpdateAction,
  sendOtpForPhoneVerificationAction,
  sendOtpForVerificationAction,
  UserProfile,
} from "../Action/user.action";
import toast, { Toaster } from "react-hot-toast";
import EmailVerificationModal from "./Modals/EmailVerificationModal";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import config from "../config/config";
import { commonService } from "../services/common.services";
import Select from "react-select";
import { components } from 'react-select';

const Profile = () => {
  const navigate = useNavigate()
  const [userdata, setuserdata] = useState({});
  const [showModal, setshowModal] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);
  const [phoneVerificationLoading, setphoneVerificationLoading] =
    useState(false);
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [timer, setTimer] = useState(60);
  const [isTimerActive, setIsTimerActive] = useState(true);
  const [image_file, setimage_file] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState(""); // Add state for mobile number
  const [countryCode, setCountryCode] = useState("in");
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [locationDataError, setLocationDataError] = useState({ countryError: "", stateError: "", cityError: "" })

  useEffect(() => {
    getStepMintProfile();
    getCountryList()
  }, []);

  useEffect(() => {
    if (userdata.country_id) {
      getStateList(userdata.country_id); // Fetch states for the user's country
    }
    if (userdata.state_id) {
      getCityList(userdata.state_id); // Fetch cities for the user's state
    }
  }, [userdata]);

  // Get State,City,Country

  const getCountryList = async () => {
    try {
      const response = await commonService.getWithOutToken('/getusercountrylist', {});
      if (response.success) {
        setCountryList(response.data);
        console.log(response, "countrylist");

      } else {
        toast.error(response.msg);
      }
    } catch (error) {
      console.error("Error fetching country list:", error);
      toast.error("Failed to fetch country list.");
    }
  }
  const getStateList = async (country) => {
    try {
      let data = { countryid: country || 101 }; // Default to India if no country is provided
      const response = await commonService.getWithOutToken('/getstatelist', data);
      if (response.success) {
        setStateList(response.data);

      } else {
        toast.error(response.msg);
      }
    } catch (error) {
      console.error("Error fetching state list:", error);
      toast.error("Failed to fetch state list.");
    }
  }

  const getCityList = async (state) => {
    try {
      let data = { stateid: state || 101 }; // Default to India if no country is provided
      const response = await commonService.getWithOutToken('/getcitylist', data);
      if (response.success) {
        setCityList(response.data);
      } else {
        toast.error(response.msg);
      }
    } catch (error) {
      console.error("Error fetching city list:", error);
      toast.error("Failed to fetch city list.");
    }
  }

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setuserdata((old) => ({ ...old, [name]: value }));
    if (name === "email") {
      setEmail(value);
    }
  };

  const handlePhoneChange = (value, data) => {
    setMobile(value.slice(data.dialCode.length));
    setCountryCode(data.dialCode);
  };

  const validate = () => {
    let countryError = "";
    let stateError = "";
    let cityError = "";
    if (!userdata.country_id) {
      countryError = "Please select a country.";
    }

    if (!userdata.state_id) {
      stateError = "Please select a state.";
    }

    if (!userdata.city_id) {
      cityError = "Please select a city.";
    }

    if (countryError || stateError || cityError) {
      setLocationDataError({
        countryError,
        stateError,
        cityError
      })
      return false;
    } else {
      return true;
    }
  }

  const SubmitForm = async (e) => {
    e.preventDefault();

    setFirstNameError("");
    setLastNameError("");

    const trimmedFirstName = userdata.first_name?.trim();
    const trimmedLastName = userdata.last_name?.trim();

    // Validation for first name and last name
    let hasError = false;

    if (!trimmedFirstName) {
      setFirstNameError("First name is required.");
      hasError = true;
    }
    if (!trimmedLastName) {
      setLastNameError("Last name is required.");
      hasError = true;
    }
    const isValid = validate();
    if (!isValid) {
      return;
    }

    if (hasError) {
      return;
    }

    let old_profile_pic = "";
    if (!image_file) {
      old_profile_pic = userdata?.profile_pic || "";
    }

    let userDatawithoutemail = {
      first_name: userdata?.first_name || "",
      last_name: userdata?.last_name || "",
      bio: userdata?.bio || "",
      profile_pic: image_file,
      old_profile_pic: old_profile_pic,
      city_id: userdata.city_id || null,
      whichquerytorun: "updateuser_without_email",
    };

    let userDatawithemail = {
      ...userDatawithoutemail,
      email: userdata.email,
    };

    const profileData =
      email === userdata.email ? userDatawithoutemail : userDatawithemail;

    let res2 = await ProfileUpdateAction(profileData);
    if (res2.success) {
      toast.success(res2.msg);
      navigate(-1)
    } else {
      toast.error(
        res2.msg || "No changes made. Please modify before updating."
      );
    }
  };

  const getStepMintProfile = async () => {
    let res = await UserProfile();
    if (res.success) {
      setuserdata(res.data);
      setMobile(res.data.mobile || "");
      setCountryCode(res.data.country_code?.replace('+', '') || '');
      setEmail(res.data.email);
    }
  };

  const handleVerifyEmail = (email) => {
    setVerificationStatus(email);
    setphoneVerificationLoading(false);
    if (email) {
      sendOtpForVerification(email);
    } else {
      toast.error("Please enter email");
    }
  };

  const handleVerifyPhone = (phone) => {
    if (!/^\d{10}$/.test(mobile)) {
      toast.error("WhatsApp number must be 10 digits.");
    } else {
      setVerificationStatus(phone);
      setLoading(false);
      if (mobile) {
        sendOtpForVerification(phone);
      } else {
        toast.error("Please enter WhatsApp Number.");
      }
    }

  };

  const sendOtpForVerification = async (emailss) => {
    if (!/^[\w-]+(\.[\w-]+)*@[a-zA-Z\d-]+(\.[a-zA-Z]{2,})+$/.test(email)) {
      setEmailError("Invalid email format. Please enter a valid email.");
      return;
    }
    if (emailss === "email") {
      setEmailError("");
      setLoading(true);
    } else {
      setphoneVerificationLoading(true);
    }
    try {
      let res;
      if (emailss === "email") {
        let emaildata = {
          email: email,
        };
        res = await sendOtpForVerificationAction(emaildata);
      }
      if (emailss === "mobile") {
        let data = {
          phone: mobile,
          countryCode: `+${countryCode}`,
        };
        res = await sendOtpForPhoneVerificationAction(data);
        console.log(res, "respos")
      }

      if (res.success) {
        setIsTimerActive(true);
        setTimer(60);
        setshowModal(true);
        if (emailss === "mobile") {
          const jsonString = JSON.stringify({
            phone: res.data[0].phone,
            countryCode: res.data[0].countryCode,
            phoneVerified: res.data[0].phoneVerified,
            orderId: res.data[0].orderId,
          });
          localStorage.setItem("userDetailsforPhoneVerification", jsonString);
        }
        setphoneVerificationLoading(false);
        setLoading(false);
        toast.success(res.msg);
      } else {
        toast.error(res.msg);
        setLoading(false);
        setphoneVerificationLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      setphoneVerificationLoading(false);
      toast.error("An error occurred.");
    }
  };
  // Country options
  const countryOptions = countryList.map((country) => ({
    value: country.id,
    label: country.name, // Use plain text for search
    iso2: country.iso2?.toLowerCase() || 'un', // For flag rendering
  }));


  // State options
  const stateOptions = stateList.map((state) => ({
    value: state.id,
    label: state.name,
  }));
  const selectedState = stateOptions.find(
    (option) => option.value == userdata.state_id
  ) || null;

  // City options
  const cityOptions = cityList.map((city) => ({
    value: city.id,
    label: city.name,
  }));
  const selectedCity = cityOptions.find(
    (option) => option.value == userdata.city_id
  ) || null;


  const SingleValue = (props) => (
    <components.SingleValue {...props}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <img
          src={`https://flagcdn.com/w40/${props.data.iso2}.png`}
          alt={props.data.label}
          style={{ width: 20, height: 14, objectFit: 'cover' }}
        />
        <span>{props.data.label}</span>
      </div>
    </components.SingleValue>
  );

  const Option = (props) => (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <img
          src={`https://flagcdn.com/w40/${props.data.iso2}.png`}
          alt={props.data.label}
          style={{ width: 20, height: 14, objectFit: 'cover' }}
        />
        <span>{props.data.label}</span>
      </div>
    </components.Option>
  );


  return (
    <>
      <Dashboardheader />
      <Toaster />

      <div className="shape_bg">
        <img src="assets/images/shape.svg" className="shape" alt="shap" />
        <img src="assets/images/shape1.svg" className="shape1" alt="shap2" />
        <img src="assets/images/shape2.svg" className="shape2" alt="shap3" />
        {/* <img src="assets/images/shape.svg" className="shape3" />
          <img src="assets/images/shape1.svg" className="shape4" /> */}
      </div>
      <div className="page-wrapper">
        <div className="position-relative overflow-hidden mt-5 pt-2 mb-5">
          <div className=" mb-5">
            <Container className="">
              <Row>
                <Col lg={2}></Col>
                <Col lg={8} className="">
                  <div className="card card-view rounded-20 p-4 position-relative">
                    <img
                      src="assets/images/nftbg1.png"
                      className="position-absolute w-100"
                      style={{
                        top: 0,
                        height: "25%",
                        zIndex: -1,
                        opacity: 0.8,
                        left: 0,
                      }}
                      alt=""
                    />

                    <div className="card-body p-3">
                      <Col lg={12} className="mb-3">
                        <div>
                          <Row>
                            <Col className="text-center d-flex flex-column align-items-center">
                              <div className="w-100 d-flex flex-row mt-4 justify-content-center gap-4">
                                {/* <img src="assets/images/nftbox2.svg" alt="" /> */}
                                <div
                                  style={{
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    width: 100,
                                    height: 100,
                                    border: "3px solid white",
                                  }}
                                >
                                  <img
                                    className="  w-100 h-100"
                                    style={{ objectFit: "cover" }}
                                    src={`${config.imageUrl}${userdata.profile_pic}`}
                                    alt=""
                                  />
                                </div>
                                {/* <img src="assets/images/nftbox2.svg" alt="" /> */}
                              </div>
                              <h3 style={{ fontWeight: 600 }} className="mt-3 sofia-sans">
                                {userdata?.first_name} {userdata?.last_name}
                              </h3>
                              <div className="profile-rank">
                                <p className="mb-0 sofia-sans">
                                  Rank :
                                  {/* <span className="profile-rank-text ">{userdata?.user_rank}</span> */}
                                  <span className="profile-rank-text sofia-sans">
                                    {userdata?.user_rank}
                                  </span>
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <br />
                        <Row>
                          <Col lg={12} className="">
                            <Row>
                              <Col lg={6}>
                                <div className="mb-4">
                                  <Form.Group controlId="formBasicEmail">
                                    <Form.Label>First name</Form.Label>
                                    <Form.Control
                                      onChange={inputHandler}
                                      name="first_name"
                                      value={
                                        userdata?.first_name
                                          ? userdata?.first_name
                                          : ""
                                      }
                                      type="name"
                                      placeholder="First name"
                                    />
                                    {firstNameError && (
                                      <div className="text-danger">
                                        {firstNameError}
                                      </div>
                                    )}
                                  </Form.Group>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-4">
                                  <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Last name</Form.Label>
                                    <Form.Control
                                      onChange={inputHandler}
                                      name="last_name"
                                      value={
                                        userdata?.last_name
                                          ? userdata?.last_name
                                          : ""
                                      }
                                      type="name"
                                      placeholder="Last name"
                                    />
                                    {lastNameError && (
                                      <div className="text-danger">
                                        {lastNameError}
                                      </div>
                                    )}
                                  </Form.Group>
                                </div>
                              </Col>
                            </Row>
                           
                            <div className="mb-4">
                              <Form.Group controlId="formBasicEmail">
                                <Form.Label>Email</Form.Label>
                                {userdata?.is_email_verify ? (
                                  <>
                                    <Row>
                                      {/* <div className="d-flex flex-row align-items-center gap-2">  */}
                                      <div
                                        style={{
                                          position: "relative",
                                          display: "inline-block",
                                        }}
                                      >
                                        <Form.Control
                                          onChange={inputHandler}
                                          name="email"
                                          value={
                                            userdata?.email
                                              ? userdata?.email
                                              : ""
                                          }
                                          type="email"
                                          disabled={userdata?.is_email_verify}
                                          placeholder="Email"
                                          style={{
                                            paddingRight: "40px",
                                            background: "#00000057",
                                            color: "#747474",
                                          }}
                                        />
                                        {userdata?.is_email_verify && (
                                          <MdVerified
                                            style={{
                                              position: "absolute",
                                              right: "23px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                              width: 25,
                                              height: 25,
                                              color: "green",
                                              borderRadius: "50%",
                                              pointerEvents: "none", // Makes sure the icon doesn't interfere with input
                                            }}
                                          />
                                        )}
                                      </div>
                                    </Row>
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <Row className="gy-3">
                                      <Col lg={9}>
                                        <Form.Control
                                          onChange={inputHandler}
                                          name="email"
                                          value={
                                            userdata?.email
                                              ? userdata?.email
                                              : ""
                                          }
                                          type="email"
                                          placeholder="Email"
                                        />
                                        {firstNameError && (
                                          <div className="text-danger">
                                            {firstNameError}
                                          </div>
                                        )}
                                      </Col>
                                      <Col lg={3}>
                                        <Button
                                          variant="main2"
                                          className="text-white w-100"
                                          style={{ height: 45 }}
                                          onClick={() =>
                                            handleVerifyEmail("email")
                                          }
                                          disabled={loading} // Disable button when loading
                                        >
                                          {loading ? (
                                            <Spinner
                                              animation="border"
                                              size="sm"
                                              role="status"
                                            >
                                              <span className="visually-hidden">
                                                Loading...
                                              </span>
                                            </Spinner>
                                          ) : (
                                            <Link
                                              className="text-light"
                                              style={{
                                                textDecoration: "none",
                                                fontSize: 14,
                                              }}
                                            >
                                              Verify
                                            </Link>
                                          )}
                                        </Button>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                {emailError && (
                                  <div className="text-danger">
                                    {emailError}
                                  </div>
                                )}
                              </Form.Group>
                            </div>
                            <Row>
                              <div className="mb-4">
                                <Form.Group controlId="formBasicEmail">
                                  <Form.Label>Whatsapp number</Form.Label>
                                  {userdata?.is_phone_verify ? (
                                    <>
                                      <Row>
                                        <div
                                          className="mb-3"
                                          style={{
                                            position: "relative",
                                            display: "inline-block",
                                          }}
                                        >
                                          <Form.Group controlId="formBasicEmail">
                                            <PhoneInput
                                              country={"in"}
                                              enableSearch={true}
                                              disabled={
                                                userdata?.is_phone_verify ===
                                                  false ||
                                                  userdata.is_phone_verify ===
                                                  undefined
                                                  ? false
                                                  : true
                                              }
                                              className="w-100 fc"
                                              style={{
                                                backgroundColor:
                                                  "transparent !important",
                                                borderColor:
                                                  "#828282 !important",
                                              }}
                                              value={`${userdata.country_code ||
                                                userdata.country_code
                                                }${userdata.mobile}`}
                                              name="mobile"
                                              onChange={inputHandler}
                                              placeholder="Enter mobile number"
                                            />
                                            {userdata?.is_phone_verify && (
                                              <MdVerified
                                                style={{
                                                  position: "absolute",
                                                  right: "23px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  width: 25,
                                                  height: 25,
                                                  color: "green",
                                                  borderRadius: "50%",
                                                  pointerEvents: "none",
                                                }}
                                              />
                                            )}
                                          </Form.Group>
                                        </div>
                                      </Row>
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      <Row className="gy-3">
                                        <Col lg={9}>
                                          <PhoneInput
                                            country={"in"}
                                            enableSearch={true}
                                            className="w-100 fc"
                                            style={{
                                              backgroundColor:
                                                "transparent !important",
                                              borderColor: "#828282 !important",
                                            }}
                                            value={`${91 || userdata.countryCode
                                              }${userdata.mobile}`}
                                            name="mobile"
                                            onChange={handlePhoneChange}
                                            placeholder="Enter mobile number"
                                          />
                                        </Col>
                                        <Col lg={3}>
                                          <Button
                                            variant="main2"
                                            className="text-white w-100"
                                            style={{ height: 45 }}
                                            onClick={() =>
                                              handleVerifyPhone("mobile")
                                            }
                                            disabled={phoneVerificationLoading}
                                          >
                                            {phoneVerificationLoading ? (
                                              <Spinner
                                                animation="border"
                                                size="sm"
                                                role="status"
                                              >
                                                <span className="visually-hidden">
                                                  Loading...
                                                </span>
                                              </Spinner>
                                            ) : (
                                              <Link
                                                className="text-light"
                                                style={{
                                                  textDecoration: "none",
                                                  fontSize: 14,
                                                }}
                                              >
                                                Verify
                                              </Link>
                                            )}
                                          </Button>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </Form.Group>
                              </div>
                            </Row>

                            <Row>
                              <Col lg={12} className="sign-up-form">
                                <Form.Group className="">
                                  <Form.Label>Select Country</Form.Label>
                                  <Select
                                    className="react-select sign-up-form"
                                    classNamePrefix="react-select"
                                    name="country_id"
                                    value={countryOptions.find((opt) => opt.value == userdata.country_id) || null}
                                    onChange={(selectedOption) => {
                                      const e = {
                                        target: {
                                          name: "country_id",
                                          value: selectedOption?.value || "",
                                        },
                                      };
                                      inputHandler(e);
                                      setStateList([]);
                                      setCityList([]);
                                      getStateList(selectedOption?.value);
                                    }}
                                    options={countryOptions}
                                    components={{ SingleValue, Option }} // ✅ flag support
                                    placeholder="Select Country"
                                    isSearchable
                                  />
                                  <span className="validationError">{locationDataError.countryError}</span>
                                </Form.Group>
                              </Col>


                            </Row>
                            <Row className="py-3">
                              <Col lg={6} className="sign-up-form">
                                {/* State Dropdown */}
                                <Form.Group className="mb-3">
                                  <Form.Label>Select State</Form.Label>
                                  <Select
                                    className="react-select sign-up-form"
                                    classNamePrefix="react-select"
                                    name="state_id"
                                    value={selectedState}
                                    onChange={(selectedOption) => {
                                      const e = {
                                        target: {
                                          name: "state_id",
                                          value: selectedOption?.value || "",
                                        },
                                      };
                                      inputHandler(e);
                                      setCityList([]);
                                      getCityList(selectedOption?.value);
                                    }}
                                    options={stateOptions}
                                    placeholder="Select State"
                                    isSearchable
                                  />
                                  <span className="validationError">{locationDataError.stateError}</span>
                                </Form.Group>

                              </Col>

                              <Col lg={6} className="sign-up-form">
                                {/* City Dropdown */}
                                <Form.Group className="mb-3">
                                  <Form.Label>Select City</Form.Label>
                                  <Select
                                    className="react-select sign-up-form"
                                    classNamePrefix="react-select"
                                    name="city_id"
                                    value={selectedCity}
                                    onChange={(selectedOption) => {
                                      const e = {
                                        target: {
                                          name: "city_id",
                                          value: selectedOption?.value || "",
                                        },
                                      };
                                      inputHandler(e);
                                    }}
                                    options={cityOptions}
                                    placeholder="Select City"
                                    isSearchable
                                  />
                                  <span className="validationError">{locationDataError.cityError}</span>
                                </Form.Group>

                              </Col>
                            </Row>
 {userdata?.country_name && (
                              <div className="mb-4">
                                <Form.Group controlId="formBasicEmail">
                                  <Form.Label>Country Timezone</Form.Label>
                                  <Form.Control
                                    onChange={inputHandler}
                                    style={{
                                      paddingRight: "40px",
                                      background: "#00000057",
                                      color: "#747474",
                                    }}
                                    name="Country"
                                    value={
                                      userdata?.country_name
                                        ? userdata?.country_name
                                        : ""
                                    }
                                    type="name"
                                    placeholder="Country"
                                    disabled
                                  />
                                </Form.Group>
                              </div>
                            )}
                            {userdata?.bnb_address && (
                              <div className="mb-4">
                                <Form.Group controlId="formBasicEmail">
                                  <Form.Label>Wallet address</Form.Label>
                                  <Form.Control
                                    onChange={inputHandler}
                                    disabled
                                    name="bnb_address"
                                    value={
                                      userdata?.bnb_address
                                        ? userdata?.bnb_address
                                        : ""
                                    }
                                    type="name"
                                    placeholder="Wallet address"
                                  />
                                </Form.Group>
                              </div>
                            )}
                            {userdata.referredBy && (
                              <div className="mb-4">
                                <Form.Group controlId="formBasicEmail">
                                  <Form.Label>Referred by</Form.Label>
                                  <Form.Control
                                    onChange={inputHandler}
                                    disabled
                                    name="refer_by"
                                    value={
                                      userdata?.referredBy
                                        ? userdata?.referredBy
                                        : ""
                                    }
                                    type="name"
                                    placeholder="Referral by "
                                  />
                                </Form.Group>
                              </div>
                            )}

                            <Button
                              variant="main2"
                              onClick={SubmitForm}
                              className="cst-btn text-white px-4"
                              style={{ textDecoration: "none", fontSize: 16 }}
                            >
                              Update Profile
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                  </div>
                </Col>
                <Col lg={2} sm={12}></Col>
              </Row>
            </Container>
            {showModal && (
              <EmailVerificationModal
                setshowModal={setshowModal}
                showModal={showModal}
                email={userdata?.email}
                mobile={mobile}
                verificationStatus={verificationStatus}
                countryCode={countryCode}
                setIsTimerActive={setIsTimerActive}
                isTimerActive={isTimerActive}
                timer={timer}
                setTimer={setTimer}
                handleVerifyPhone={handleVerifyPhone}
                handleVerifyEmail={handleVerifyEmail}
                loading={loading}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile;
